<div class="bee-loading-wrapper">
    <mat-progress-spinner
    mode="indeterminate">
    </mat-progress-spinner>
</div>